













import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import OnsiteEventsCalendar from '@ui/Calendar/OnsiteEventsCalendar'
import OngoingEventsCalendar from '@ui/Calendar/OngoingEventsCalendar'

settings =
  name: 'VenueCalendarStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      OnsiteEventsCalendar,
      OngoingEventsCalendar,
    }

    data: ->
      calendar: null
      listingClass: @wizard.audienceSetData.listing_class

    mounted: ->
      @initializeCalendar()

    methods:
      initializeCalendar: ->
        if @wizard.selectedCalendar
          @calendar = @wizard.selectedCalendar
          return
  
        calendar = @wizard.prototypeForCalendar()
        @wizard.audienceSetData.calendars[calendar.key] = calendar
        @wizard.selectedAudienceAvailability.calendar_key = calendar.key
        @wizard.syncAndSave()
        @calendar = @wizard.selectedCalendar

export default VueOptions.vue settings
